export const alertWindowReached = ({ context }) => !!context.alertWindowDays && context.alertWindowDays <= 14;
export const managerResponded = ({ context }) => !!context.managerResponded;
//# sourceMappingURL=contract-alert.js.map